import useUserPoint from './useUserPoint'
import styles from './UserPoint.module.scss'
import { UserPointProps } from './types'

const UserPoint = (props: UserPointProps) => {
  const { placement, haloSizeStyle, haloColorStyle } = useUserPoint(props)

  return (
    <>
      {placement ? (
        <div
          className={styles.userPointRoot}
          style={{ left: `${placement.x}px`, top: `${placement.y}px` }}
        >
          <div
            className={`${styles.pointHalo} ${haloColorStyle || styles.light} ${haloSizeStyle || styles.medium}`}
          />
        </div>
      ) : null}
    </>
  )
}

export default UserPoint
